<template>
  <div class="trip-box">
    <query-menu></query-menu>
  </div>
</template>
<script>
import queryMenu from './components/queryMenu'
import './index'
export default {
  components: {
    queryMenu
  },
  created () {
    window.__MICRO_ROOT__?.api?.track?.('home_view')
  }
}
</script>
